const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const zipRegex = /^\d{5}$|^\d{5}-\d{4}$/;
const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;

export default {
  onboarding: {
    first_name: [v => !!v || "First name is required"],
    last_name: [v => !!v || "Last name is required"],
    email: [
      v => !!v || "Email is required",
      v => emailRegexp.test(v) || "Incorrect email"
    ],
    password: [
      v => !!v || "Password is required",
      v =>
        (v && v.length >= 6) ||
        "Password too short. Must be as least 6 characters"
    ],
    phone: [
      v => !v || phoneRegex.test(v) || "Please use the format 555-555-5555"
    ],
    street_address_1: [v => !!v || "Street address is required"],
    city: [v => !!v || "City is required"],
    state: [v => !!v || "State is required"],
    zip_code: [
      v => !!v || "Zip Code is required",
      v => !v || zipRegex.test(v) || "Invalid Zip Code"
    ],
    photo_release: [
      v =>
        !!v ||
        "You must agree to the photo release terms and the terms and conditions."
    ]
  }
};
